/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MachineUploadDateFields,
    MachineUploadDateFieldsFromJSON,
    MachineUploadDateFieldsFromJSONTyped,
    MachineUploadDateFieldsToJSON,
} from './MachineUploadDateFields';

/**
 * 
 * @export
 * @interface MachineSaleListSearchFilterModel
 */
export interface MachineSaleListSearchFilterModel {
    /**
     * 
     * @type {number}
     * @memberof MachineSaleListSearchFilterModel
     */
    machineId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineSaleListSearchFilterModel
     */
    cityId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineSaleListSearchFilterModel
     */
    districtId?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof MachineSaleListSearchFilterModel
     */
    categoryIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof MachineSaleListSearchFilterModel
     */
    subCategoryIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof MachineSaleListSearchFilterModel
     */
    brandIds?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof MachineSaleListSearchFilterModel
     */
    minPrice?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineSaleListSearchFilterModel
     */
    maxPrice?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof MachineSaleListSearchFilterModel
     */
    hasPicture?: boolean | null;
    /**
     * 
     * @type {MachineUploadDateFields}
     * @memberof MachineSaleListSearchFilterModel
     */
    machineUploadDate?: MachineUploadDateFields;
    /**
     * 
     * @type {number}
     * @memberof MachineSaleListSearchFilterModel
     */
    minProductionYear?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineSaleListSearchFilterModel
     */
    maxProductionYear?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineSaleListSearchFilterModel
     */
    minOperatingWeight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineSaleListSearchFilterModel
     */
    maxOperatingWeight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineSaleListSearchFilterModel
     */
    minOperationHour?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineSaleListSearchFilterModel
     */
    maxOperationHour?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineSaleListSearchFilterModel
     */
    minCarryingCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineSaleListSearchFilterModel
     */
    maxCarryingCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineSaleListSearchFilterModel
     */
    minOperatingHeight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineSaleListSearchFilterModel
     */
    maxOperatingHeight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineSaleListSearchFilterModel
     */
    minOperationMillage?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineSaleListSearchFilterModel
     */
    maxOperationMillage?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineSaleListSearchFilterModel
     */
    minEnginePower?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineSaleListSearchFilterModel
     */
    maxEnginePower?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineSaleListSearchFilterModel
     */
    minMaxPower?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineSaleListSearchFilterModel
     */
    maxMaxPower?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineSaleListSearchFilterModel
     */
    minVolume?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineSaleListSearchFilterModel
     */
    maxVolume?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MachineSaleListSearchFilterModel
     */
    drivingEquipment?: string | null;
}

export function MachineSaleListSearchFilterModelFromJSON(json: any): MachineSaleListSearchFilterModel {
    return MachineSaleListSearchFilterModelFromJSONTyped(json, false);
}

export function MachineSaleListSearchFilterModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): MachineSaleListSearchFilterModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'machineId': !exists(json, 'machineId') ? undefined : json['machineId'],
        'cityId': !exists(json, 'cityId') ? undefined : json['cityId'],
        'districtId': !exists(json, 'districtId') ? undefined : json['districtId'],
        'categoryIds': !exists(json, 'categoryIds') ? undefined : json['categoryIds'],
        'subCategoryIds': !exists(json, 'subCategoryIds') ? undefined : json['subCategoryIds'],
        'brandIds': !exists(json, 'brandIds') ? undefined : json['brandIds'],
        'minPrice': !exists(json, 'minPrice') ? undefined : json['minPrice'],
        'maxPrice': !exists(json, 'maxPrice') ? undefined : json['maxPrice'],
        'hasPicture': !exists(json, 'hasPicture') ? undefined : json['hasPicture'],
        'machineUploadDate': !exists(json, 'machineUploadDate') ? undefined : MachineUploadDateFieldsFromJSON(json['machineUploadDate']),
        'minProductionYear': !exists(json, 'minProductionYear') ? undefined : json['minProductionYear'],
        'maxProductionYear': !exists(json, 'maxProductionYear') ? undefined : json['maxProductionYear'],
        'minOperatingWeight': !exists(json, 'minOperatingWeight') ? undefined : json['minOperatingWeight'],
        'maxOperatingWeight': !exists(json, 'maxOperatingWeight') ? undefined : json['maxOperatingWeight'],
        'minOperationHour': !exists(json, 'minOperationHour') ? undefined : json['minOperationHour'],
        'maxOperationHour': !exists(json, 'maxOperationHour') ? undefined : json['maxOperationHour'],
        'minCarryingCapacity': !exists(json, 'minCarryingCapacity') ? undefined : json['minCarryingCapacity'],
        'maxCarryingCapacity': !exists(json, 'maxCarryingCapacity') ? undefined : json['maxCarryingCapacity'],
        'minOperatingHeight': !exists(json, 'minOperatingHeight') ? undefined : json['minOperatingHeight'],
        'maxOperatingHeight': !exists(json, 'maxOperatingHeight') ? undefined : json['maxOperatingHeight'],
        'minOperationMillage': !exists(json, 'minOperationMillage') ? undefined : json['minOperationMillage'],
        'maxOperationMillage': !exists(json, 'maxOperationMillage') ? undefined : json['maxOperationMillage'],
        'minEnginePower': !exists(json, 'minEnginePower') ? undefined : json['minEnginePower'],
        'maxEnginePower': !exists(json, 'maxEnginePower') ? undefined : json['maxEnginePower'],
        'minMaxPower': !exists(json, 'minMaxPower') ? undefined : json['minMaxPower'],
        'maxMaxPower': !exists(json, 'maxMaxPower') ? undefined : json['maxMaxPower'],
        'minVolume': !exists(json, 'minVolume') ? undefined : json['minVolume'],
        'maxVolume': !exists(json, 'maxVolume') ? undefined : json['maxVolume'],
        'drivingEquipment': !exists(json, 'drivingEquipment') ? undefined : json['drivingEquipment'],
    };
}

export function MachineSaleListSearchFilterModelToJSON(value?: MachineSaleListSearchFilterModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'machineId': value.machineId,
        'cityId': value.cityId,
        'districtId': value.districtId,
        'categoryIds': value.categoryIds,
        'subCategoryIds': value.subCategoryIds,
        'brandIds': value.brandIds,
        'minPrice': value.minPrice,
        'maxPrice': value.maxPrice,
        'hasPicture': value.hasPicture,
        'machineUploadDate': MachineUploadDateFieldsToJSON(value.machineUploadDate),
        'minProductionYear': value.minProductionYear,
        'maxProductionYear': value.maxProductionYear,
        'minOperatingWeight': value.minOperatingWeight,
        'maxOperatingWeight': value.maxOperatingWeight,
        'minOperationHour': value.minOperationHour,
        'maxOperationHour': value.maxOperationHour,
        'minCarryingCapacity': value.minCarryingCapacity,
        'maxCarryingCapacity': value.maxCarryingCapacity,
        'minOperatingHeight': value.minOperatingHeight,
        'maxOperatingHeight': value.maxOperatingHeight,
        'minOperationMillage': value.minOperationMillage,
        'maxOperationMillage': value.maxOperationMillage,
        'minEnginePower': value.minEnginePower,
        'maxEnginePower': value.maxEnginePower,
        'minMaxPower': value.minMaxPower,
        'maxMaxPower': value.maxMaxPower,
        'minVolume': value.minVolume,
        'maxVolume': value.maxVolume,
        'drivingEquipment': value.drivingEquipment,
    };
}

